import React from 'react';
import { IconType } from 'react-icons';

// Icone da React Icons FA
import { 
  FaEye, 
  FaEyeSlash, 
  FaEnvelope, 
  FaPhone, 
  FaLock,
  FaUser,
  FaCalendar,
  FaGlobe,
  FaIdCard,
  FaUpload,
  FaSpinner,
  FaCamera,
  FaShieldAlt,
  FaCheckCircle,
  FaSms,
  FaCheck,
  FaUserCircle,
  FaFacebook,
  FaGoogle,
  FaLinkedin,
  FaArrowLeft,
  FaHome,
  FaClock,
  FaEdit,
  FaExclamationTriangle,
  FaSignOutAlt,
  FaCreditCard,
  FaInstagram,
  FaTwitter,
  FaArrowUp,
  FaAward,
  FaTimes,
  FaBars,
  FaUsers,
  FaAddressBook,
  FaMapMarkerAlt,
  FaCog,
  FaSync,
  FaDownload,
  FaTrash,
  FaPlus,
  FaSearch,
  FaFilter,
  FaExternalLinkAlt,
  FaSave,
  FaBan,
  FaCertificate,
  FaTimesCircle
} from 'react-icons/fa';

// Icone da React Icons RI
import { 
  RiMailLine,
  RiPhoneLine,
  RiTimeLine,
  RiHotelLine,
  RiAuctionLine,
  RiCalendarEventLine,
  RiCompassDiscoverLine,
  RiCustomerService2Line
} from 'react-icons/ri';

// Wrapper per le icone che risolve i problemi di tipo JSX
interface IconWrapperProps {
  className?: string;
  style?: React.CSSProperties;
  size?: string | number;
  color?: string;
}

// Factory function migliorata per creare componenti icona
const createIconComponent = (Icon: IconType) => {
  const IconComponent = (props: IconWrapperProps) => {
    const TypedIcon = Icon as React.ComponentType<IconWrapperProps>;
    return <TypedIcon {...props} />;
  };
  IconComponent.displayName = `IconWrapper(${(Icon as any).displayName || (Icon as any).name || 'Icon'})`;
  return IconComponent;
};

// Auth e Form Icons
export const EyeIcon = createIconComponent(FaEye);
export const EyeSlashIcon = createIconComponent(FaEyeSlash);
export const EnvelopeIcon = createIconComponent(FaEnvelope);
export const PhoneIcon = createIconComponent(FaPhone);
export const LockIcon = createIconComponent(FaLock);
export const UserIcon = createIconComponent(FaUser);
export const CalendarIcon = createIconComponent(FaCalendar);
export const GlobeIcon = createIconComponent(FaGlobe);
export const IdCardIcon = createIconComponent(FaIdCard);
export const UploadIcon = createIconComponent(FaUpload);
export const SpinnerIcon = createIconComponent(FaSpinner);
export const CameraIcon = createIconComponent(FaCamera);
export const ShieldIcon = createIconComponent(FaShieldAlt);
export const CheckCircleIcon = createIconComponent(FaCheckCircle);
export const SmsIcon = createIconComponent(FaSms);
export const CheckIcon = createIconComponent(FaCheck);
export const UserCircleIcon = createIconComponent(FaUserCircle);

// Social Media Icons
export const FacebookIcon = createIconComponent(FaFacebook);
export const GoogleIcon = createIconComponent(FaGoogle);
export const LinkedinIcon = createIconComponent(FaLinkedin);
export const InstagramIcon = createIconComponent(FaInstagram);
export const TwitterIcon = createIconComponent(FaTwitter);

// Navigation Icons
export const ArrowLeftIcon = createIconComponent(FaArrowLeft);
export const ArrowUpIcon = createIconComponent(FaArrowUp);
export const CloseIcon = createIconComponent(FaTimes);
export const MenuIcon = createIconComponent(FaBars);

// Business Icons
export const HomeIcon = createIconComponent(FaHome);
export const ClockIcon = createIconComponent(FaClock);
export const EditIcon = createIconComponent(FaEdit);
export const ExclamationTriangleIcon = createIconComponent(FaExclamationTriangle);
export const SignOutIcon = createIconComponent(FaSignOutAlt);
export const LogOutIcon = createIconComponent(FaSignOutAlt);
export const CreditCardIcon = createIconComponent(FaCreditCard);
export const AwardIcon = createIconComponent(FaAward);
export const TeamIcon = createIconComponent(FaUsers);
export const ContactsIcon = createIconComponent(FaAddressBook);
export const SettingsIcon = createIconComponent(FaCog);
export const RefreshIcon = createIconComponent(FaSync);
export const DownloadIcon = createIconComponent(FaDownload);
export const TrashIcon = createIconComponent(FaTrash);
export const PlusIcon = createIconComponent(FaPlus);
export const SearchIcon = createIconComponent(FaSearch);
export const FilterIcon = createIconComponent(FaFilter);
export const ExternalLinkIcon = createIconComponent(FaExternalLinkAlt);
export const SaveIcon = createIconComponent(FaSave);
export const BlockIcon = createIconComponent(FaBan);
export const VerifiedIcon = createIconComponent(FaCertificate);
export const XCircleIcon = createIconComponent(FaTimesCircle);

// Service Icons
export const HotelIcon = createIconComponent(RiHotelLine);
export const AuctionIcon = createIconComponent(RiAuctionLine);
export const EventIcon = createIconComponent(RiCalendarEventLine);
export const ExperienceIcon = createIconComponent(RiCompassDiscoverLine);
export const CustomerServiceIcon = createIconComponent(RiCustomerService2Line);

// Location and Contact Icons
export const MapPinIcon = createIconComponent(FaMapMarkerAlt);
export const MailIcon = createIconComponent(RiMailLine);
export const PhoneLineIcon = createIconComponent(RiPhoneLine);
export const TimeIcon = createIconComponent(RiTimeLine);

// Componente generico IconWrapper per uso flessibile
interface GenericIconWrapperProps extends IconWrapperProps {
  children: React.ReactNode;
}

export const IconWrapper: React.FC<GenericIconWrapperProps> = ({ 
  children, 
  className, 
  style,
  ...props 
}) => (
  <span 
    className={className} 
    style={style}
    {...props}
  >
    {children}
  </span>
); 